import * as React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import LoggedOutBar from './LoggedOutBar';
import LoggedInBar from './LoggedInBar';
import Typography from '@mui/material/Typography';

function NavBar({ mode, toggleColorMode }) {
  // const location = useLocation();
  // console.log(location.pathname);
  const isLoggedIn = localStorage.getItem('accessToken');

  return (
    <div>
      {isLoggedIn ? (
        <>
          {/* <Typography variant="body2" color="text.primary">
            Logged In
          </Typography> */}
          <LoggedInBar mode={mode} toggleColorMode={toggleColorMode} />
        </>
      ) : (
        <>
          {/* <Typography variant="body2" color="text.primary">
            Logged Out
          </Typography> */}
          <LoggedOutBar mode={mode} toggleColorMode={toggleColorMode} />
        </>
      )}
    </div>
  );
}

NavBar.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']).isRequired,
  toggleColorMode: PropTypes.func.isRequired
};

export default NavBar;
